export var STAY_DETAILS_STATE_INITIAL_VALUE = {
  data: {
    info: {
      suggestion: {
        location: {
          latitude: '',
          longitude: ''
        },
        placeId: '',
        hotelId: ''
      }
    }
  }
};
export var SEARCH_REFERRER_INITIAL_VALUE = {
  data: {
    referrer: ''
  }
};
export var DISTANCE_FROM_SEARCH_INITIAL_VALUE = {
  data: {
    distance: 0
  }
};